import loopback from './loopback'

/**
 * Feature flags por usuario.
 *
 * O pbxapi guarda uma linha (feature_flag, user_id) na tabela `rollouts` e o
 * endpoint `/rollout` responde ALLOWED ou DENIED para o usuario da sessao. Nao
 * ha porcentagem nem grupo: quem esta na tabela ve, o resto nao ve.
 *
 * Para liberar alguem, o backend expoe (com header `api-key`):
 *   POST   /rollouts/users/:userId   { "featureName": "ia4com" }
 *   GET    /rollouts/users/:userId
 *   DELETE /rollouts/:rolloutId
 */

/** o item do menu e a pagina precisam concordar no nome — por isso ele mora aqui */
export const IA4COM_FEATURE_FLAG = 'ia4com'

/**
 * Erro de rede nao pode abrir a porta: qualquer falha responde negado, que e o
 * estado seguro para um recurso ainda restrito.
 */
export function isFeatureAllowed (featureFlag) {
  return loopback
    .get(`/rollout?featureFlag=${featureFlag}`)
    .then(rollout => rollout === 'ALLOWED')
    .catch(error => {
      console.error(error)
      return false
    })
}

export default { isFeatureAllowed, IA4COM_FEATURE_FLAG }



// WEBPACK FOOTER //
// ./src/services/rollout.js